import { render, staticRenderFns } from "./qushi.vue?vue&type=template&id=5b7ae90c&scoped=true&"
import script from "./qushi.vue?vue&type=script&lang=ts&"
export * from "./qushi.vue?vue&type=script&lang=ts&"
import style0 from "./qushi.vue?vue&type=style&index=0&id=5b7ae90c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7ae90c",
  null
  
)

export default component.exports